import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { KeyPadService } from './services/key-pad/key-pad.service';

import { DirectivesModule } from '@components/directives/directives.module';
import { SharedModule } from '@shared/shared.module';

import {
  KeypadButtonComponent,
  KeypadComponent,
  KeypadContainerComponent,
  KeypadDisplayComponent,
  KeypadInputComponent,
} from './components/keypad';
import { MainPipe } from '@app/shared/helpers/pipes/main-pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { KeypadPanelComponent } from './components/keypad-panel/keypad-panel.component';

const KEYPAD_COMPONENTS = [
  KeypadComponent,
  KeypadPanelComponent,
  KeypadContainerComponent,
  KeypadDisplayComponent,
  KeypadButtonComponent,
  KeypadInputComponent,
];

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    SharedModule,
    MainPipe,
    TranslateModule,
  ],
  declarations: [...KEYPAD_COMPONENTS],
  exports: [...KEYPAD_COMPONENTS],
  providers: [KeyPadService],
})
export class KeyPadModule {}
